// extracted by mini-css-extract-plugin
export default {"base":"vp_cuKAv","prompt":"vp_RcLwR","border-dance":"vp_ieRDJ","question":"vp_Mbs07"};